<template>
  <a-dropdown :trigger="['hover', 'click']">
    <a-space :style="{ color: color}">
      <Icon icon="icon-park-outline:user" width="25" height="25" :color="color"
            @mouseover="color = 'rgb(24, 144, 255)'" @mouseout="color = 'rgba(255,255,255,0.7)'"/>
      <div @mouseover="color = 'rgb(24, 144, 255)'" @mouseout="color = 'rgba(255,255,255,0.7)'" style="font-size: 0.7rem">
            管理员
          </div>
    </a-space>

    <template #overlay>
      <a-menu class="avatarMenu">
        <a-menu-item>
          <span style="width:100px" @click="editInfo" type="text">修改个人信息</span>
        </a-menu-item>
        <a-menu-item>
          <span style="width:100px" @click="editPwd" type="text">修改密码</span>
        </a-menu-item>
        <a-menu-item>
          <span style="width:100px" @click="logout" type="text">退出登录</span>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>

</template>
<script>
import {Icon} from '@iconify/vue'

export default {
  name: 'PersonalCenter',
  components: {Icon},
  data() {
    return {
      color: 'rgba(255,255,255)',
      timer: null,
    }
  },
  methods: {
    /**
     * 退出登录
     */
    async logout() {
      // 刷新页面
      this.$router.push('/login')
    },

    editInfo() {
    },

    editPwd() {
    }
  }

}
</script>
<style lang="less" scoped> 

</style>

